/**
 * @file
 * Behaviors for the Chatbot component.
 */

!((Drupal) => {
  (function(global) {
    'use strict';
    var MESSENGER_URL =
      '/themes/custom/nitaac/dist/js/messenger-internal.min.js?v=4.1';

    var loadDfMessenger = function() {
      if (window.location.href.indexOf('/nitaac-university') === -1) {
        var elementScript = document.createElement('script');
        elementScript.addEventListener('load', onMessengerLoaded, false);
        elementScript.src = MESSENGER_URL;
        global.document.body.insertBefore(elementScript, null);
      }
    };

    var onMessengerLoaded = function() {
      window.dispatchEvent(new Event('dfMessengerLoaded'));

      const shadowroot = document.querySelector('df-messenger').shadowRoot;
      const chatbotButton = shadowroot.querySelector('#widgetIcon');
      const chatTextBubble = shadowroot.querySelector('.chat-text-bubble');
      const chatTextBubbleClose = shadowroot.querySelector(
        '.df-messenger-wrapper button#widgetIcon .chat-text-bubble .close-bubble'
      );

      let numberOfVisitedPages =
        parseInt(sessionStorage.getItem('numberOfVisitedPages')) || 0;

      // If there is not session storage key of 'numberOfVisitedPages'
      // or the number of pages a user visited is less than three pages,
      // then hide the chat text helper.  Increase the number of
      // visited pages and set the session storage variable equal to
      // that number.
      if (
        !sessionStorage['numberOfVisitedPages'] ||
        (numberOfVisitedPages < 2 &&
          window.location.href.indexOf('/nitaac-university') === -1)
      ) {
        numberOfVisitedPages++;
        sessionStorage.setItem('numberOfVisitedPages', numberOfVisitedPages);

        // Hide the help text on the contract holders page.  For all
        // other pages, show the help text after the user is on the
        // page for 30 seconds
        if (window.location.href.indexOf('/search/contract-holders') == -1) {
          setTimeout(() => {
            // If the user hasn't clicked the chat button within the set Timeout, execute code.
            if (!sessionStorage.getItem('chatbotOpened')) {
              chatbotButton.classList.replace(
                'pulsate-chat-widget',
                'expanded-chat-widget'
              );
              setTimeout(() => {
                // Chat Text Close Icon appears after a second
                chatTextBubble.style.display = 'inline-block';
              }, 1000);
            }
          }, 30000);
        }
      }
      else if (
        window.location.href.indexOf('/search/contract-holders') > -1 ||
        sessionStorage.getItem('chatbotOpened')
      ) {
        // If the page is not the contract holder directory or the user
        // has previously opened the chatbot, hide the chatbot text bubble.
        chatTextBubble.style.display = 'none';
      }
      else {
        // If user has visited more than 3 pages, show help text
        chatbotButton.classList.remove('pulsate-chat-widget');
        chatbotButton.classList.add('expanded-chat-widget');
        setTimeout(() => {
          chatTextBubble.style.display = 'inline-block';
        }, 1000);
      }

      //Once the user clicks on the chatbot icon, set session cookie that will
      // hide the chatbot text bubble for the remainder of the user's session.
      // Determine if the chatbot button should pulsate based on button status.
      chatbotButton.addEventListener('click', () => {
        sessionStorage.setItem('chatbotOpened', true);

        if (!chatbotButton.classList.contains('expanded-chat-widget')) {
          chatbotButton.classList.toggle('pulsate-chat-widget');
        }
        else {
          // Remove the chatbot button expansion, but don't pulsate the
          // chatbot button as the chatbot has been opened.
          chatbotButton.classList.remove('expanded-chat-widget');
        }

        chatTextBubble.style.removeProperty('display');
      });

      // When chat text bubble close icon is clicked, add class to pulsate
      // the chatbot button and hide the close icon and text.
      chatTextBubbleClose.addEventListener('click', (e) => {
        e.stopPropagation();
        chatbotButton.classList.remove('expanded-chat-widget');
        setTimeout(() => {
          chatbotButton.classList.add('pulsate-chat-widget');
        }, 0);
        chatTextBubble.style.removeProperty('display');
      });
    };

    global.addEventListener('load', loadDfMessenger);
  })(window);
})(Drupal);
